import { MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';
import { MenuItemRegistry } from '@menu-lib/components/AppLayout/MainMenu/menuRegistry';
import {
  defaultTellingen,
  type EnvironmentSettings,
  type LinkItem,
} from '@menu-lib/components/AppLayout/types';

MenuItemRegistry.register(MenuItems.Schade, {
  isVisible: () => true,
  create: (settings: EnvironmentSettings): LinkItem => {
    const tellingen = settings.tellingen ?? defaultTellingen;

    return {
      itemtype: 'link',
      menuItem: MenuItems.Schade,
      title: 'Schade',
      url: '/app/aanvraag/recente-activiteiten/schade',
      iconclass: 'fas fa-car-burst',
      showbadge: !!tellingen.aantalSchades,
      badgecontent: tellingen.aantalSchades,
      target: '_top',
    };
  },
});
